module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor07-9622596535002f3e6d358aeeafb1e248.png";